// extracted by mini-css-extract-plugin
module.exports = {"OuterBox":"RecipeBox_OuterBox__2PvEF","Heading":"RecipeBox_Heading__2_lfX","Recipes":"RecipeBox_Recipes__2GHkq"};